import { FormSectionGroup } from '@vwfs-bronson/bronson-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AddressFormNew } from '../../../../components/AddressFormNew';
import { BankDetailsNew } from '../../../../components/BankDetailsNew';
import { CustomerDetailsFormNew } from '../../../../components/CustomerDetailsFormNew';
import { journeyDataSelectors } from '../../../../services/redux/features/journeyData.slice';
import { useFormSectionHelpers } from '../../../utils';

const orderedForms = ['customerDetails', 'customerAddress', 'bankDetails'] as const;
type FormId = (typeof orderedForms)[number];

export const CustomerDataServicePlan = () => {
  const [forms, setForms] = useState<FormId[]>([...orderedForms]);

  // When in Standalone Service Plan user selected Upfront payment for service plan,
  // then we do not need Bank Details PC-2305

  const isUpfrontPayment = useSelector(journeyDataSelectors.isUpfrontPayment);

  useEffect(() => {
    const sections = [
      'customerDetails',
      'customerAddress',
      ...(isUpfrontPayment ? [] : (['bankDetails'] satisfies FormId[])),
    ] as FormId[];

    setForms(sections);
  }, [isUpfrontPayment]);

  const getFormHelpers = useFormSectionHelpers(forms);

  return (
    <FormSectionGroup>
      <CustomerDetailsFormNew.SP formHelpers={getFormHelpers('customerDetails')} />
      <AddressFormNew.SP formHelpers={getFormHelpers('customerAddress')} />
      {!isUpfrontPayment && (
        <BankDetailsNew.SP
          formHelpers={getFormHelpers('bankDetails')}
          titleTranslationKey="bankDetailsForm:title:private"
        />
      )}
    </FormSectionGroup>
  );
};
